import {
    SET_ROUTE_DATA,
    SET_PARTIALS_DATA,
    SET_THEME,
    SET_COOKIE_CONSENT_DATA,
} from 'vue/vuex/mutation-types';

import * as getters from './getters';
import * as actions from './actions';


const DEFAULT_THEME = 'neutral';
const DEFAULT_NAV_THEME = 'base';

/**
 * The mutations available in the module
 */
const mutations = {
    [SET_ROUTE_DATA](state, { key, value }) {
        state.routes[key] = value;
    },
    [SET_PARTIALS_DATA](state, { key, value }) {
        state.partials[key] = value;
    },
    [SET_THEME](state, { theme, navTheme }) {
        state.theme = theme || DEFAULT_THEME;
        state.navTheme = navTheme || DEFAULT_NAV_THEME;
    },
    [SET_COOKIE_CONSENT_DATA](state, { data }) {
        state.cookieConsentData = data;
    },
};

/**
 * The state of the module
 */
const state = {
    routes: {},
    partials: {},
    theme: DEFAULT_THEME,
    navTheme: DEFAULT_NAV_THEME,
    cookieConsentData: null,
};


export default {
    actions,
    state,
    getters,
    mutations,
};



// WEBPACK FOOTER //
// ./sib-website/assets/src/js/app/vue/vuex/modules/router/index.js